import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import $ from 'jquery';
import { IMAGES } from '../../../constants';
import MetaData from '../../layout/MetaData';
import { url } from '../../../config';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { toast, ToastContainer } from 'react-toastify';
import { loadUser, logout } from '../../../actions/userActions';


const Confirmation = () => {

    const dispatch = useDispatch()

    useEffect(() => {
        $('#busi-info-sidebar').addClass('active visited')
        $('#bill-info-sidebar').addClass('active visited')
    }, [])

    useEffect(() => {
        // dispatch(loadUser({}))
    }, [])

    const user = useSelector(state => state.user)

    const user_data = sessionStorage.getItem('user');

    useEffect(() => {
        
        if (user_data){
            setTimeout(() => {
            dispatch(logout());
            localStorage.removeItem('isAuthenticated');
            sessionStorage.removeItem('user');
        }, 1000);
        }
        
    }, [])

    const handleClick = () =>{
        window.location.href =url
    }
    return (
        <Fragment>
            <MetaData title={`confirmation`} />
            <div className="card2 ml-2">
                <div className="row w-100 mt-3 justify-content-center">
                    <div className="col-md-8 ">
                        <img src={IMAGES.LOGO_BLUE} alt="" className="d-block m-auto" style={{ width: "300px", maxWidth: "90%" }}  />
                        {/* <img src={IMAGES.WHITE_LOGO} alt="" className="d-block m-auto" /> */}

                        <div className="confrim_box">
                            <div className="con_1">
                               
                                <h2 className="font-26 NewTitle">
                                    <FormattedMessage
                                        id="confirm.heading"
                                        defaultMessage=""
                                    />
                                </h2>
                                <p className="font-20 black-3B fr">
                                    <FormattedMessage
                                        id="confirm.discription"
                                        defaultMessage=""
                                    />
                                </p>
                            </div>
                        <div>

                        <img src={IMAGES.welcome_img} alt="" className="d-block m-auto w-75" />
                        </div>

                            {/* <div className="con_2">
                                <p className="email"><span>{user?.user?.email}</span> <img src="images/edit.png" alt="" /></p>
                                <p>
                                    <FormattedMessage
                                        id="confirm.message-tag"
                                        defaultMessage="We will notify your activation very soon by email after we review your documents"
                                    />
                                </p>
                            </div> */}
                            {/* <Link to={url} className="back_home btn btn-white"> */}
                            {/* <button onClick={handleClick} className="back_home btn btn-white"> */}
                            <div className='HweBTNGroup'>
                            <button onClick={handleClick} className="back_home btn btnFUll_Bg">
                            <FormattedMessage
                                    id="confirm.return-home"
                                    defaultMessage="Home"
                                />
                            </button>
                            </div>
                                
                            {/* </Link> */}
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                autoClose={2500}
                hideProgressBar={true}
                className="toast-chilling"
                position="top-right"
                newestOnTop={false}
                closeOnClick={true}
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={false}
                theme="light"
            />

        </Fragment>
    )
}

export default Confirmation

